// @flow
import { OficinasActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    oficina: {},
    listaOficinas: [],
    loading: false,
    error: false,
    formSubmited: false
};

type OficinasAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { oficina?: {} | null, listaOficinas?: [] | null, loading?: boolean, +value ?: boolean };

const Oficinas = (state: State = INIT_STATE, action: OficinasAction): any => {
    // console.log(action);
    switch (action.type) {
        case OficinasActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case OficinasActionTypes.GET_OFICINA: {
                    return {
                        ...state,
                        oficina: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case OficinasActionTypes.LIST_OFICINAS: {
                    return {
                        ...state,
                        listaOficinas: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case OficinasActionTypes.ADD_OFICINA: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case OficinasActionTypes.UPDATE_OFICINA: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        oficina: action.payload.data,
                        formSubmited: true
                    };
                }
                case OficinasActionTypes.DELETE_OFICINA: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case OficinasActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case OficinasActionTypes.GET_OFICINA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        oficina: {},
                        loading: false,
                    };
                }
                case OficinasActionTypes.LIST_OFICINAS: {
                    return {
                        ...state,
                        error: true,
                        listaOficinas: [],
                        loading: false,
                    };
                }
                case OficinasActionTypes.ADD_OFICINA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case OficinasActionTypes.UPDATE_OFICINA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case OficinasActionTypes.DELETE_OFICINA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case OficinasActionTypes.GET_OFICINA:
            return { ...state, error: false, loading: true };
        case OficinasActionTypes.LIST_OFICINAS:
            return { ...state, error: false, loading: true };
        case OficinasActionTypes.ADD_OFICINA:
            return { ...state, error: false, loading: false };
        case OficinasActionTypes.UPDATE_OFICINA:
            return { ...state, error: false, loading: false };
        case OficinasActionTypes.DELETE_OFICINA:
            return { ...state, error: false, loading: false };
        case OficinasActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                oficina: {},
                listaOficinas: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Oficinas;
